<template>
  <div class="com-match-card" @click="openMatch">
    <OutOpen
      :protocol="heyboxProtocol"
      :page-identifier="'bbs/link'"
      v-if="canUseDeepLink && articleInfo.source == 'share'"
    ></OutOpen>
    <template v-if="!is_loading">
      <div class="team-1">
        <img v-hb-img.src="card_data.team1_icon" alt="" class="team-icon" />
        <span class="team-name">{{ card_data.team1_name }}</span>
      </div>
      <div class="match-info-wrapper">
        <p class="line-1">{{ time }}</p>
        <div class="line-2">
          <svg
            v-for="item in 3"
            :key="'left_' + item"
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6 10L3.32051 0H0.21468L2.89417 10H6Z"
              :fill="
                4 - item <= card_data.team1_score
                  ? 'rgba(100, 105, 110, 1)'
                  : 'rgba(243, 244, 245, 1)'
              "
            />
          </svg>
          <div
            class="watched"
            v-if="state == 'watched'"
            @click="toggleWatchMatchState('unwatch')"
          >
            已订阅
          </div>
          <div
            class="unwatched"
            v-else-if="state == 'unwatched'"
            @click="toggleWatchMatchState('watch')"
          >
            订阅
          </div>
          <div class="commingsoon" v-else-if="state == 'commingsoon'">
            即将开始
          </div>
          <div class="inmatch" v-else-if="state == 'inmatch'">比赛中</div>
          <div class="aftermatch" v-else>
            <span
              class="team-score"
              :class="{ weight: card_data.team1_score > card_data.team2_score }"
              >{{ card_data.team1_score }}</span
            >
            <span class="colon">:</span>
            <span
              class="team-score"
              :class="{ weight: card_data.team2_score > card_data.team1_score }"
              >{{ card_data.team2_score }}</span
            >
          </div>
          <svg
            v-for="item in 3"
            :key="'right_' + item"
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 10L2.67949 0H5.78532L3.10583 10H0Z"
              :fill="
                item <= card_data.team2_score
                  ? 'rgba(100, 105, 110, 1)'
                  : 'rgba(243, 244, 245, 1)'
              "
            />
          </svg>
        </div>
        <p class="line-3">{{ card_data.league_name }}</p>
      </div>
      <div class="team-2">
        <img v-hb-img.src="card_data.team2_icon" alt="" class="team-icon" />
        <span class="team-name">{{ card_data.team2_name }}</span>
      </div>
    </template>
  </div>
</template>
<script>
import { executeProtocol, executeProtocolOutApp } from '_lib/utils';
import { timeHandler } from '../../../assets/js/utils';
import { CptMixin } from '../../../mixins/CptMixin';
import { toggleWatchMatchState } from '_api/bbs/post-article/index';
import OutOpen from '_com/OutOpen';
const STATE_ENUM = {
  0: 'aftermatch',
  1: 'watched',
  2: 'unwatched',
  3: 'commingsoon',
  4: 'inmatch',
};
export default {
  mixins: [CptMixin],
  props: {
    canUseDeepLink: {
      type: Boolean,
    },
  },
  data() {
    return {
      is_loading: true,
      card_data: {},
      state: '',
      time: '',
    };
  },
  created() {
    this.getData();
  },
  components: {
    OutOpen,
  },
  methods: {
    async getData() {
      const {
        data: {
          result: { matches },
          status,
        },
      } = await this.dataInfo.request;
      if (status != 'ok') {
        return;
      }
      this.card_data = matches.find((_) => _.id == this.dataInfo.id);
      if (!this.card_data) return;
      // console.log('[match_data]', this.card_data);
      this.state = STATE_ENUM[this.card_data.match_state];
      this.time =
        this.state == 'inmatch'
          ? '已开始'
          : '' + timeHandler(this.card_data.start_time);
      this.is_loading = false;
    },
    async toggleWatchMatchState(type) {
      if (this.lock) return;
      this.lock = true;
      const {
        data: { status },
      } = await toggleWatchMatchState(type, {
        match_id: this.dataInfo.id,
      });
      if (status != 'ok') {
        this.$hb_toast.failed(type == 'unwatch' ? '取消订阅失败' : '订阅失败');
        return;
      }
      this.state = type == 'watch' ? 'watched' : 'unwatched';
      this.$hb_toast.success(type == 'unwatch' ? '取消订阅成功' : '订阅成功');
      this.lock = false;
    },
    openMatch() {
      switch (this.articleInfo.source) {
        case 'share': {
          executeProtocolOutApp(this.heyboxProtocol);
          break;
        }
        case 'post': {
          executeProtocol(this.heyboxProtocol);
          break;
        }
      }
    },
  },
  computed: {
    heyboxProtocol() {
      let protocol = {
        protocol_type: 'openWindow',
        full_screen: true,
        mini_program: '1',
        mini_program_id: '24',
        status_bar: {
          style: 'light',
        },
        navigation_bar: {
          title: ' ',
          right_icon: {
            enabled: false,
          },
        },
        webview: {
          url:
            window.$WEB_HOST +
            `/tools/match_center/match_detail?match_id=${this.dataInfo.id}&hash_tag_id=${this.dataInfo.hash_tag_id}`,
          pull: false,
          refresh: false,
        },
      };
      return 'heybox://' + encodeURIComponent(JSON.stringify(protocol));
    },
  },
};
</script>

<style lang="less">
.com-match-card {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  margin-top: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(250, 251, 252, 1);
  &::after {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border-radius: 16px;
    border: 1px solid rgba(243, 244, 245, 1);
    transform: scale(0.5);
    transform-origin: left top;
    pointer-events: none;
  }
  .team-1,
  .team-2 {
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 114px;
    height: 80px;
    .team-icon {
      width: 42px;
      height: 42px;
      object-fit: scale-down;
    }
    .team-name {
      width: 82px;
      height: 18px;
      margin-top: 6px;
      font-size: 13px;
      line-height: 18px;
      color: rgba(20, 25, 30, 1);
      text-align: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .team-1 {
    left: 0;
  }
  .team-2 {
    right: 0;
  }
  .match-info-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    line-height: 14px;
    .line-1 {
      font-size: 11px;
      color: rgba(140, 145, 150, 1);
    }
    .line-2 {
      display: flex;
      align-items: center;
      width: 160px;
      margin: 7px 0;
      font-size: 11px;
      color: rgba(140, 145, 150, 1);
      .unwatched,
      .watched,
      .commingsoon,
      .inmatch,
      .aftermatch {
        margin: 0 auto;
      }
      .aftermatch {
        display: flex;
        align-items: flex-start;
        .team-score {
          width: 18px;
          height: 24px;
          padding: 0px 3px;
          font-size: 22px;
          line-height: 24px;
          background: rgba(243, 244, 245, 1);
          border-radius: 3px;
          text-align: center;
          font-family: 'TG-TYPE-Bold';
          color: rgba(200, 205, 210, 1);
          &.weight {
            color: rgba(20, 25, 30, 1);
          }
        }
        .colon {
          margin: 3px 9px 0;
          font-size: 22px;
          color: rgba(200, 205, 210, 1);
          font-family: PingFang SC;
        }
      }
      .watched,
      .commingsoon {
        padding: 4px 12px;
        border-radius: 3px;
        background: rgba(243, 244, 245, 1);
        font-size: 12px;
        font-weight: 500;
        color: rgba(20, 25, 30, 1);
        line-height: 16px;
      }
      .unwatched {
        padding: 4px 12px;
        border-radius: 3px;
        background: rgba(20, 25, 30, 1);
        font-size: 12px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
      }
      .inmatch {
        padding: 4px 12px;
        border-radius: 3px;
        background: rgba(50, 184, 70, 1);
        font-size: 12px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
      }
    }
    .line-3 {
      font-size: 10px;
      color: rgba(140, 145, 150, 1);
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>
